module.exports = __webpack_public_path__ + "static/media/star-fgn.f1061e37.png";